import { render, staticRenderFns } from "./supplierResourceManageDetail.vue?vue&type=template&id=15bc4c84&scoped=true"
import script from "./supplierResourceManageDetail.vue?vue&type=script&lang=js"
export * from "./supplierResourceManageDetail.vue?vue&type=script&lang=js"
import style0 from "./supplierResourceManageDetail.vue?vue&type=style&index=0&id=15bc4c84&lang=scss&scoped=true"
import style1 from "./supplierResourceManageDetail.vue?vue&type=style&index=1&id=15bc4c84&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc4c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15bc4c84')) {
      api.createRecord('15bc4c84', component.options)
    } else {
      api.reload('15bc4c84', component.options)
    }
    module.hot.accept("./supplierResourceManageDetail.vue?vue&type=template&id=15bc4c84&scoped=true", function () {
      api.rerender('15bc4c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/supplierResourceManageDetail.vue"
export default component.exports